import { SuscriptionStatusEnum } from '../../../common/interfaces/movement.interface'

export const SUSCRIPTION_STATUS_BADGE_CLASS: Record<SuscriptionStatusEnum, string> = {
  [SuscriptionStatusEnum.PENDING]: 'badge-light-warning',
  [SuscriptionStatusEnum.INPROGRESS]: 'badge-light-primary',
  [SuscriptionStatusEnum.APPROVED]: 'badge-light-success',
  [SuscriptionStatusEnum.ANNULLED]: 'badge-light-danger',
  [SuscriptionStatusEnum.FAILED]: 'badge-light-danger',
}
